import * as React from "react"
import { Link } from "gatsby"
import Sidebar from './sidebar/sidebar'
import './header.scss'
import UnderAttack from './underAttack'
import M from 'materialize-css';
import subservices from './subservices'
import isBrowser from "../isBrowser"

const companyMenu = {
  "":[{title:"About Us", path:"/about_us"}, { title:"Contact", path:"/contact_us"}],
}


const allListItems = [
  {
    name:"Home",
    path: "/",
    isSubmenu:false,
  },
  {
    name:"Arka",
    path: "/arka",
    isSubmenu:false,
  },
  {
    name:"Services",
    path: "#!",
    isSubmenu:true,
    menu:subservices
  },
  {
    name:"Company",
    path: "#!",
    isSubmenu:true,
    menu:companyMenu,
    isShort:true,
  },
  {
    name:"Pricing",
    path: "/pricing",
    isSubmenu:false,
  },
  {
    name:"Resources",
    path: "https://ulogx.com/",
    target:"_blank",
    externalLink:true,
    isSubmenu:false,
  },
]



const Header = () => {

  const dropdown = (menu) => (
    <ul className="dropdown-menu z-depth-1">
      {
        Object.keys(menu).map((keyName, i) => (
          <li className="col" key={i}>
            {
              keyName && (
                <>
                  <span>{ keyName }</span>
                  <hr/>
                </>
              )
            }
            <ul>
              {
                menu[keyName].map((service, j)=>(
                  <li  key={j}>
                    <Link to={service.path}>
                      {service.title}
                    </Link>
                  </li>
                ))
              }
            </ul>
          </li>
        ))
      }
    </ul>
  )


  //This function is for only the top div containing email and phone number
  // const changePosition = () => {
  //   var navbar = document.querySelector("nav");
  //   if(window.scrollY > document.querySelector(".top-div").scrollHeight){
  //     navbar.classList.remove('absolute');
  //   }else{
  //     navbar.classList.add('absolute');
  //   }
  // }

  
  const modalOpen = ()=>{
    if (  isBrowser() ){
      var elem = document.querySelector('.modal#underAttack');
      var instance = M.Modal.getInstance(elem);
      instance.open();
    }
  }

  React.useEffect(() => {

    const abortControl = new AbortController();

    // if ( isBrowser() )
    // window.onscroll = changePosition;
     

    return () => { abortControl.abort(); }

  }, [])


  return (
    <header className="header">
      <div className="navbar-fixed">
        <nav className="desktop-nav">
          <div className=" nav-wrapper content-div">
            <Link to="/" className="brand-logo" id="brand-logo">
              <img className="logo"
                src={`/logo_png/navbar.png`}
                alt="Mr.Pentester"
              />
            </Link>


            <ul className="middle-content">
              {/* long menu */}
              {/* for short menu add short menu className to li tag */}
              {
                allListItems.map((item, i)=>(
                  <li key={i} className={ item.isSubmenu ? "dropdown-toggle " + (item.isShort ? "short-menu" : null) : null}>
                    { item.externalLink ? 
                      <a href={ item.path } target="_blank" rel="noopener noreferrer">
                        { item.name }
                      </a> :
                      <Link to={item.isSubmenu ? "#!" :item.path} onClick={(e)=>{if(e.target.getAttribute('href') === "/#!") e.preventDefault();}} target={item.target} >
                        { item.name }
                        { item.isSubmenu &&  <i className="fa fa-caret-down"></i> }
                      </Link>
                    }
                    { item.isSubmenu && dropdown(item.menu) }
                  </li>
                ))
              }
            </ul>


            <a href="#!" data-target="menu-bar" className="sidenav-trigger">
              <i className="fa fa-bars"></i>
            </a>

            <ul className="right-content">
              <span className="hide-on-med-and-down">
                <li>
                  <Link to='/log_in' className="btn login">
                    Login
                  </Link>
                </li>
                <li>
                  <a href="#!" onClick={(e)=>{e.preventDefault(); modalOpen();}}  className="btn under-attack">
                    Under Attack?
                  </a>
                </li>
              </span>
            </ul>
          </div>
        </nav>
      </div>
      <Sidebar menu={allListItems} />
      <UnderAttack id="underAttack" title="Under Attack" />
    </header>
  )
}



export default Header;
